import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import SmoothScroll from "./components/SmoothScroll";
import { AuthProvider } from "./context/AuthContext";
import { MessagingProvider } from "./context/MessagingContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import WhatWeDo from "./pages/WhatWeDo";
import EazymuvOS from "./pages/EazymuvOS";
import Products from "./pages/Products";
import EazyMS from "./pages/EazyMS";
import Industries from "./pages/Industries";
import HowWeWork from "./pages/HowWeWork";
import About from "./pages/About";
import Team from "./pages/Team";
import Careers from "./pages/Careers";
import { Insights, InsightDetail } from "./pages/Insights";
import Contact from "./pages/Contact";
import { Privacy, Terms, NotFound } from "./pages/Legal";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <MessagingProvider>
            <SmoothScroll>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/what-we-do" element={<WhatWeDo />} />
              <Route path="/eazymuv-os" element={<EazymuvOS />} />
              <Route path="/products" element={<Products />} />
              <Route path="/eazyms" element={<EazyMS />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/how-we-work" element={<HowWeWork />} />
              <Route path="/about" element={<About />} />
              <Route path="/team" element={<Team />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </SmoothScroll>
          <Toaster position="bottom-right" richColors />
          </MessagingProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
